import { Button, Card, Divider, Form, Input,Radio,Typography } from 'antd';
import React, { useState,useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import api from '../../../../../apis';
import { showMessageModal,showSuccessMessageModal } from '../../../../utils';
import { useNavigate } from 'react-router-dom'; 
const { Title, Text } = Typography;

//prod sitekey
const recaptcha_auth ="6Lf1WY0rAAAAAJtXtDw1ydtXssNk-kFBRNOuH3vr"


const Index = ({}) => {
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaToken2, setCaptchaToken2] = useState(null);
   
    const [contactMethod, setContactMethod] = useState('email');
    const [resetMethod, setResetMethod] = useState('change_password');
    const [idType, setIdType] = useState('nric');
    const [isSending, setIsSending] = useState(false);
    const [cooldown, setCooldown] = useState(0);
    const [tacChecksum, setTacChecksum] = useState('');

    const [step, setStep] = useState(1);

    const [form] = Form.useForm();
    const [form2] = Form.useForm();

    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const id = 'recaptcha-enterprise';
        if (document.getElementById(id)) {
          setLoaded(true);
          return;
        }
    
        const script = document.createElement('script');
        script.id = id;
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptcha_auth}`;
        script.async = true;
        script.defer = true;
        script.onload = () => setLoaded(true);
        document.head.appendChild(script);
    
        return () => {
    
        };
      }, []);


    const handleCaptchaChange = (token) => {
      console.log("Captcha token:", token);
      setCaptchaToken(token);
      // Send this token to backend for verification
    };

    const handleCaptchaChange2 = (token) => {
        console.log("Captcha token:", token);
        setCaptchaToken2(token);
        // Send this token to backend for verification
      };

    const onFinishForm1 = (values) => {
        // if (!captchaToken) {
        //   showMessageModal('Please complete the CAPTCHA.');
        //   return;
        // }
    
        // Combine form values and captcha token here
        console.log('Form values:', values);
        handleVerifyTAC(values);
 
    };

    const onFinishForm2 = (values) => {
        // if (!captchaToken2) {
        //     showMessageModal('Please complete the CAPTCHA.');
        //     return;
        // }
      
        if(resetMethod == 'change_password'){
            handleResetPassword(values);
        }else if(resetMethod == 'unblock_account'){
            handleUnblockAccount(values);
        }
    };
    

    const handleResetPassword = async (values) => {
        try {

            window.grecaptcha.enterprise.ready(async () => {
                const token = await window.grecaptcha.enterprise.execute(recaptcha_auth, {
                action: 'PASSWORD_RESET',
                });

                console.log('handleResetPassword values:', values);

                const result = await api.resetPassword(values,token);
                console.log('result:', result);
              
                if(result){
                    if(result.status == 0){
                      //  showSuccessMessageModal("handleVerifyTAC successful.");
    
                        showSuccessMessageModal("You have successfully chosen a new password");
                        navigate('/login');
                    }else{
                        showMessageModal(result.message);
                    }
                }
      
        
            })
     
            

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    }

    const handleUnblockAccount = async (values) => {
        try {

            window.grecaptcha.enterprise.ready(async () => {
                const token = await window.grecaptcha.enterprise.execute(recaptcha_auth, {
                action: 'PASSWORD_RESET',
                });

              
                console.log('handleUnblockAccount values:', values);

                const result = await api.unblockAccount({},token);
                console.log('result:', result);
              
                if(result){
                    if(result.status == 0){
                      //  showSuccessMessageModal("handleVerifyTAC successful.");
    
                        showSuccessMessageModal("Successful! Your account is unblocked. Please re-login with your existing password.” ");
                        navigate('/login');
                    }else{
                        showMessageModal(result.message);
                    }
                }
        
            })
            
     
           

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    }


    const handleSendCode = async () => {
        try {
     
            const values = form.getFieldsValue();
            const fieldsToValidate = Object.keys(values).filter(key => key !== 'code');
            const validateFields = await form.validateFields(fieldsToValidate);

            console.log('handleSendCode values:', values);


            try {
                window.grecaptcha.enterprise.ready(async () => {
                    const token = await window.grecaptcha.enterprise.execute(recaptcha_auth, {
                    action: 'PASSWORD_RESET',
                    });

            
                    const result = await api.requestTAC(values,token);
                    console.log('result:', result);
                
                    if(result){
                        if(result.status == 0){
                            showSuccessMessageModal("Request successful.");
                            let checksum = result.data.checksum;
                            setTacChecksum(checksum+"-");
                        }else{
                            showMessageModal(result.message);
                        }
                    }
                    
                    // Simulate API call to send TAC
                    setIsSending(true);
                    setCooldown(30); // 60-second cooldown
                    //   message.success(`TAC sent to ${contact}`);
                
                    const interval = setInterval(() => {
                        setCooldown((prev) => {
                        if (prev <= 1) {
                            clearInterval(interval);
                            setIsSending(false);
                            return 0;
                        }
                        return prev - 1;
                        });
                    }, 1000);
            
                })
            } catch (error) {
                console.error("reCAPTCHA execution error:", error);
                // You can display a user-friendly message
                alert("verification failed. Please try again later.");
            }

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    };

    const handleVerifyTAC = async (values) => {
        try {
     
            console.log('handleVerifyTAC values:', values);

            const result = await api.verifyTAC(values);
            console.log('result:', result);
          
            if(result){
                if(result.status == 0){
                  //  showSuccessMessageModal("handleVerifyTAC successful.");

                    setStep(2);
             
                }else{
                    showMessageModal(result.message);
                }
            }

        } catch (error) {
            showMessageModal(error)
         // message.error('Failed to send TAC code.');
        }
    }
  

    return (
        <> 
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#f5f5f5', // Optional for better visibility
                    padding: 24,
                }}
            >
            <Card  style={{ maxWidth: 600, margin: '0 auto', padding: 24, borderRadius: 12,boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                
                <div className=' register-form'>
                    <Title level={3}>	
                    	
                        Reset Password/Unblock Account</Title>
                                                <Text type="secondary">	
                            
                                                Please complete the following data associated with your UOB Kay Hian account.
                        <br/><br/>
                        Contact your authorized Dealer's Representative if your registered Mobile or Email have changed.</Text>
                        <br />
            

                        {
                            step == 1 && 
                            (
                                <>
                                    <Form form={form} layout="vertical" style={{ marginTop: 24 }}  onFinish={onFinishForm1}>
                                        <Form.Item
                                            label="User ID"
                                            name="username"
                                            rules={[{ required: true, message: 'Please enter your User ID' }]}
                                        >
                                            <Input />
                                        </Form.Item>

                                        <Divider />

                                        {/* Contact Method Radio Group */}
                                        <Form.Item label="Contact Method">
                                            <Radio.Group
                                            value={contactMethod}
                                            onChange={(e) => {
                                                const method = e.target.value;
                                                setContactMethod(method);
                                                form.setFieldsValue({ email: '', mobile: '' }); // reset both fields
                                            }}
                                        >
                                                <Radio value="email">Email Address</Radio>
                                                <Radio value="mobile">Malaysian Mobile No</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        {/* Email Input */}
                                        {contactMethod === 'email' && (
                                            <Form.Item
                                            label="Email Address"
                                            name="email"
                                            rules={[
                                                { required: true, message: 'Please enter your email address' },
                                                { type: 'email', message: 'Please enter a valid email address' },
                                            ]}
                                            >
                                            <Input placeholder="Enter your Email Address" />
                                            </Form.Item>
                                        )}

                                        {/* Mobile Input */}
                                        {contactMethod === 'mobile' && (
                                            <Form.Item
                                            label="Mobile Phone No."
                                            name="phone"
                                            rules={[
                                                { required: true, message: 'Please enter your mobile number' },
                                                { pattern: /^[0-9]+$/, message: 'Only numbers allowed' },
                                            ]}
                                            extra={<Text type="secondary">Please enter numbers only</Text>}
                                            >
                                            <Input
                                                placeholder="Enter your Mobile Number"
                                                onChange={(e) => {
                                                const numeric = e.target.value.replace(/\D/g, '');
                                                form.setFieldsValue({ mobile: numeric });
                                                }}
                                            />
                                            </Form.Item>
                                        )}

                                        <Divider />
                                        {/* Identification Type Radio Group */}
                                        <Form.Item label="Identification Type">
                                            <Radio.Group
                                                value={idType}
                                                onChange={(e) => {
                                                setIdType(e.target.value);
                                                form.setFieldsValue({
                                                    nric: '',
                                                    passport: '',
                                                    business_registration_no: ''
                                                });
                                            }}
                                            >
                                                <Radio value="nric">Malaysian NRIC No.</Radio>
                                                <Radio value="passport">Passport No.</Radio>
                                                <Radio value="business_registration_no">Business Registration No.</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        {(idType === 'nric' || idType === 'passport' || idType === 'business_registration_no') && (
                                            <Form.Item
                                                label={
                                                idType === 'nric'
                                                    ? 'Malaysian NRIC No.'
                                                    : idType === 'passport'
                                                    ? 'Passport No.'
                                                    : 'Business Registration No.'
                                                }
                                                name={idType}
                                                rules={[
                                                {
                                                    required: true,
                                                    message: `Please enter your ${
                                                    idType === 'nric'
                                                        ? 'Malaysian NRIC No.'
                                                        : idType === 'passport'
                                                        ? 'Passport No.'
                                                        : 'Business Registration No.'
                                                    }`
                                                },
                                                idType === 'nric'
                                                    ? {
                                                        pattern: /^[0-9]+$/,
                                                        message: 'Only numbers allowed (no dash or space)'
                                                    }
                                                    : {
                                                        pattern: /^[0-9a-zA-Z-]+$/,
                                                        message: 'Only alphanumeric characters and dashes allowed'
                                                    }
                                                ]}
                                            >
                                                <Input
                                                placeholder="Enter identification number"
                                                onChange={(e) => {
                                                    const raw = e.target.value;
                                                    let cleaned = raw;

                                                    if (idType === 'nric') {
                                                    cleaned = raw.replace(/[^0-9]/g, '');
                                                    } else {
                                                    cleaned = raw.replace(/[^0-9a-zA-Z-]/g, '');
                                                    }

                                                    form.setFieldsValue({ [idType]: cleaned });
                                                }}
                                                />
                                            </Form.Item>
                                        )}


                                        <Divider />
{/* 
                                        <div style={{ marginBottom: 16 }} className='d-flex justify-content-center align-items-center pt-3 pb-3'>
                                            <ReCAPTCHA
                                                sitekey={recaptcha_auth} // Replace with your actual key
                                                onChange={handleCaptchaChange}
                                                className="recaptcha-container" 
                                            />
                                        </div> */}

                                        {
                                            <>
                                            {/* TAC Code + Send Button */}
                                            <Form.Item label="TAC Code" required>
                                                <Input.Group compact>
                                                <Form.Item
                                                    name="code"
                                                    noStyle
                                                    rules={[{ required: true, message: 'Please enter the TAC code' }]}
                                                >
                                                    <Input style={{ width: '60%' }} maxLength={6}  addonBefore={tacChecksum}/>
                                                </Form.Item>
                                                <Button
                                                    style={{ width: '40%' }}
                                                    onClick={handleSendCode}
                                                    disabled={isSending}
                                                    className='btn-primary-custom  btn-tac'
                                                >
                                                    {cooldown > 0 ? `Resend in ${cooldown}s` : 'Send Code'}
                                                </Button>
                                                </Input.Group>
                                            </Form.Item>
                                        
                                        
                                        </>
                                        }

                                    

                                        <Divider />

                                        <div style={{ textAlign: 'center' }}>
                                            <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                                                Submit
                                            </Button>
                                        </div>
                                    </Form>
                                </>
                            )
                        }

                        {
                            step == 2 && 
                            (
                                <>
                                    <Divider />
                                    <Form form={form2} layout="vertical" style={{ marginTop: 24 }}  onFinish={onFinishForm2}>
                                        {/* Contact Method Radio Group */}
                                        <Form.Item label="Reset Method">
                                            <Radio.Group
                                                value={resetMethod}
                                                onChange={(e) => {
                                                    const method = e.target.value;
                                                    setResetMethod(method);
                                                    form.setFieldsValue({ password: '', unblock: '' }); // reset both fields
                                                }}
                                            >
                                                <Radio value="change_password">Change Password</Radio>
                                                <Radio value="unblock_account">Unblock Account</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        {resetMethod === 'change_password' && (
                                            <>
                                            <Form.Item
                                                label="New Password"
                                                name="password"
                                                rules={[{ required: true, message: 'Please enter the new password' }]}
                                            >
                                                <Input.Password />
                                            </Form.Item>

                                            <Form.Item
                                                label="Confirm New Password"
                                                name="confirmPassword"
                                                dependencies={['password']}
                                                rules={[
                                                { required: true, message: 'Please confirm the new password' },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Passwords do not match'));
                                                    },
                                                }),
                                                ]}
                                            >
                                                <Input.Password />
                                            </Form.Item>
                                            </>
                                        )}


                                        <Divider />

                                        <div style={{ marginBottom: 16 }} className='d-flex justify-content-center align-items-center pt-3 pb-3'>
                                            <ReCAPTCHA
                                                sitekey={recaptcha_auth} // Replace with your actual key
                                                onChange={handleCaptchaChange2}
                                                className="recaptcha-container" 
                                            />
                                        </div>

                                        <Divider />

                                        <div style={{ textAlign: 'center' }}>
                                            <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                                                Submit
                                            </Button>
                                        </div>

                                    </Form>

                                </>
                            )
                        }

                     
                    {/* <Text type="secondary" style={{ display: 'block', marginTop: 16, textAlign: 'center' }}>
                        This page requires CAPTCHA Validation to proceed. Click <a href="#">here</a> to check if your browser is supported.
                    </Text> */}
    
                </div>
            </Card>
            </div>
        </>
    );
};

export default Index;
